import reduceReducers from "reduce-reducers";
import {
  getApiPaginationReducer,
  paginatedInitialState,
} from "redux-store/api-sagas";

import {
  FULL_DEVICES_LOAD_FAILURE,
  FULL_DEVICES_LOAD_SUCCESS,
  FULL_DEVICES_UNLOAD,
} from "./actions";

const fullDevicesInitialState = {
  ...paginatedInitialState,
  all_ids: [],
};

const apiFullDeviceReducer = getApiPaginationReducer(
  FULL_DEVICES_LOAD_SUCCESS,
  FULL_DEVICES_LOAD_FAILURE,
  fullDevicesInitialState,
);

function extraReducer(state = fullDevicesInitialState, action) {
  const { type } = action;

  switch (type) {
    case FULL_DEVICES_UNLOAD:
      return fullDevicesInitialState;
    default:
      return state;
  }
}

const fullDeviceReducer = reduceReducers(apiFullDeviceReducer, extraReducer);

export { fullDeviceReducer, extraReducer };
